import React, { Component } from "react";
import PropTypes from "prop-types";
import { Grid } from "semantic-ui-react";
import { Header } from "../common";
import styles from "./styles.less";

class ErrorDialog extends Component {
  render() {
    const { titles, isRtl, isMobileView } = this.props;
    return (
      <Grid className={styles.wrapper}>
        <Grid.Row>
          <Grid.Column width={16}>
            <Header
              noSidePadding={true}
              isRtl={isRtl}
              text={titles.ErrorOccourredTitle}
              isMobileView={isMobileView}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={16}>
            <div className={styles.section}>
              <div className={styles.dataField}>{titles.ErrorOccourred}</div>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

ErrorDialog.propTypes = {
  titles: PropTypes.object,
  isMobileView: PropTypes.bool,
  isRtl: PropTypes.bool
};

export default ErrorDialog;



// WEBPACK FOOTER //
// ./src/components/ErrorDialog/ErrorDialog.js